"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var AddDown_exports = {};
__export(AddDown_exports, {
  default: () => AddDown_default
});
module.exports = __toCommonJS(AddDown_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.34533 4.9999C9.34533 4.66853 9.0767 4.3999 8.74533 4.3999C8.41396 4.3999 8.14533 4.66853 8.14533 4.9999L8.14532 17.6402L5.42426 14.9191C5.18994 14.6848 4.81004 14.6848 4.57573 14.9191C4.34142 15.1535 4.34142 15.5334 4.57573 15.7677L8.25269 19.4446C8.52605 19.718 8.96927 19.718 9.24263 19.4446L12.9196 15.7677C13.1539 15.5334 13.1539 15.1535 12.9196 14.9191C12.6853 14.6848 12.3054 14.6848 12.0711 14.9191L9.34532 17.6449L9.34533 4.9999Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16 4.3999C16.3314 4.3999 16.6 4.66853 16.6 4.9999V7.3999H19C19.3314 7.3999 19.6 7.66853 19.6 7.9999C19.6 8.33127 19.3314 8.5999 19 8.5999H16.6V10.9999C16.6 11.3313 16.3314 11.5999 16 11.5999C15.6686 11.5999 15.4 11.3313 15.4 10.9999V8.5999H13C12.6686 8.5999 12.4 8.33127 12.4 7.9999C12.4 7.66853 12.6686 7.3999 13 7.3999H15.4V4.9999C15.4 4.66853 15.6686 4.3999 16 4.3999Z",
      fill: "currentColor"
    }
  )
);
const SvgAddDown = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var AddDown_default = SvgAddDown;
